import {
  CheckCircleIcon,
  CircleDashedIcon,
  ClockIcon,
} from '@phosphor-icons/react';
import { css, html } from 'react-strict-dom';
import { Api } from 'src/api';
import { Text } from 'src/components';
import { Color, Style } from 'src/constants';
import { color } from 'src/constants/color.css';
import { Model } from 'src/models';

type Skill = Api.Ticket.V_AvailableList['skills'][number];

type Props = {
  skill: Skill;
};

function getStatusIcon(status: string | null) {
  if (status === 'done')
    return { Icon: CheckCircleIcon, iconColor: Color.green };
  if (status === 'awaiting_review')
    return { Icon: ClockIcon, iconColor: Color.yellow };
  return { Icon: CircleDashedIcon, iconColor: Color.neutral60 };
}

export default function SkillBadge({ skill }: Props) {
  const { Icon, iconColor } = getStatusIcon(skill.status);

  return (
    <html.span style={[Style.inline, Style.alignCenter, styles.badge]}>
      <Icon size={14} color={iconColor} />
      <Text typeface="caption.medium" color="neutral80">
        {Model.TicketSkill.getTypeName(skill.type)}
      </Text>
    </html.span>
  );
}

const styles = css.create({
  badge: {
    gap: 4,
    borderRadius: 100,
    backgroundColor: color.neutral10,
    paddingInline: 8,
    paddingBlock: 4,
    whiteSpace: 'nowrap',
  },
});
